module.exports = _.isBoolean;